module.exports = __webpack_public_path__ + "static/img/index_img_5.8f1d969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_img_5.jpg
// module id = PjNB
// module chunks = 0